import axios, { AxiosInstance } from 'axios';
import { getValidToken } from 'components/Auth/Authenticator';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_VERSION}/`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

export const APIClient = (): AxiosInstance => {
  axiosInstance.interceptors.request.use(
    async (config) => {
      const token = await getValidToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
  return axiosInstance;
};
